import React, { Component } from 'react';
import { Button, Card, Cascader, Col, DatePicker, Form, Input, Radio, Row, Select } from 'antd';
import moment from 'moment';
import { BackBtn, goBack } from '@comm/BackBtn';
import { queryCustomCategory } from '@api/crm/crm';
import chinaAddressOptions from '../../comm/cascader-address-options';
import SelectUser from '../../comm/SelectUser';

const { Option } = Select;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: [],
    };
  }

  componentWillMount() {
    queryCustomCategory().then(res => {
      if (res.statusCode === 200) {
        const data = res.data.map(item => {
          item.isLeaf = false;
          return item;
        });
        this.setState({
          category: data,
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const key = nextProps.data.category1;
    if (!key) {
      return false;
    }
    queryCustomCategory().then(res => {
      if (res.statusCode === 200) {
        const data = res.data.map(item => {
          item.isLeaf = false;
          return item;
        });
        if (!key) {
          this.setState({
            category: data,
          });
          return;
        }
        queryCustomCategory(key).then(result => {
          if (result.statusCode === 200) {
            data.map(item => {
              if (item.key === key) {
                item.children = result.data;
              }
              return item;
            });
            this.setState({
              category: data,
            });
          }
        });
      }
    });
  }

  loadCategory = selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;

    queryCustomCategory(targetOption.value).then(req => {
      if (req.statusCode === 200) {
        targetOption.loading = false;
        targetOption.children = req.data;
      }
    });
  };

  chaneCategory = value => {
    if (value.length > 0) {
      this.props.form.setFieldsValue({
        category1: value[0],
        category2: value[1],
      });
    }
  };

  chaneRegion = value => {
    if (value.length > 0) {
      this.props.form.setFieldsValue({ province: value[0], city: value[1] });
    }
  };

  changeOrderUser = (value, selectedOptions) => {
    this.props.form.setFieldsValue({
      orderName: selectedOptions.props.children,
    });
  };

  changeRecommendUser = (value, selectedOptions) => {
    this.props.form.setFieldsValue({
      recommendName: selectedOptions.props.children,
    });
  };

  changeManagerUser = (value, selectedOptions) => {
    this.props.form.setFieldsValue({
      managerName: selectedOptions.props.children,
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handleSubmit, data } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (data && data.uuid) {
          values.uuid = data.uuid;
        }

        values.establishedDate = values.establishedDate
          ? values.establishedDate.format('YYYY-MM-DD')
          : undefined;
        handleSubmit(values);
      }
    });
  };

  changeType = () => {
    // TODO 当是个人时隐去一些信息
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    getFieldDecorator('province', { initialValue: data ? data.province : '' });
    getFieldDecorator('city', { initialValue: data ? data.city : '' });
    getFieldDecorator('category1', {
      initialValue: data ? data.category1 : '',
    });
    getFieldDecorator('category2', {
      initialValue: data ? data.category2 : '',
    });
    getFieldDecorator('orderName', {
      initialValue: data ? data.orderName : '',
    });
    getFieldDecorator('recommendName', {
      initialValue: data ? data.recommendName : '',
    });
    getFieldDecorator('managerName', {
      initialValue: data ? data.managerName : '',
    });
    const ItemLayout2 = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };

    const ItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };

    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: 15, marginTop: '-45px' }}>
          <BackBtn />
        </div>
        <Card title="基本信息">
          <Row>
            <Col span={10}>
              <FormItem label="公司名称" {...ItemLayout2}>
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: '请输入公司名称!' }],
                  initialValue: data ? data.name : '',
                })(<Input placeholder="公司名称" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="单位类型" {...ItemLayout2}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请选择单位类型!' }],
                  initialValue: data ? data.type : '1',
                })(
                  <Select onChange={this.changeType}>
                    <Option key="1" value="1">
                      公司
                    </Option>
                    <Option key="0" value="0">
                      个人
                    </Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="曾用名" {...ItemLayout2}>
                {getFieldDecorator('oldName', {
                  initialValue: data ? data.oldName : '',
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="企业成立时间" {...ItemLayout2}>
                {getFieldDecorator('establishedDate', {
                  initialValue: data.establishedDate
                    ? moment.unix(data.establishedDate / 1000)
                    : undefined,
                })(<DatePicker style={{ width: '100%' }} />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="组织机构代码" {...ItemLayout2}>
                {getFieldDecorator('code', {
                  initialValue: data ? data.code : '',
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="企业规模(人)" {...ItemLayout2}>
                {getFieldDecorator('scale', {
                  initialValue: data ? data.scale : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="注册地址" {...ItemLayout}>
                {getFieldDecorator('registerAddr', {
                  initialValue: data ? data.registerAddr : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="客户行业" {...ItemLayout2}>
                {getFieldDecorator('category', {
                  initialValue: data ? data.category : [],
                })(
                  <Cascader
                    options={this.state.category}
                    loadData={this.loadCategory}
                    onChange={this.chaneCategory}
                    fieldNames={{
                      label: 'key',
                      value: 'value',
                      children: 'children',
                    }}
                    changeOnSelect
                    placeholder="请选择客户行业"
                  />,
                )}
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span={20}>
              <FormItem label="主营业务" {...ItemLayout}>
                {getFieldDecorator('business', {
                  initialValue: data ? data.business : '',
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="公司网址" {...ItemLayout}>
                {getFieldDecorator('website', {
                  initialValue: data ? data.website : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="公司简介" {...ItemLayout}>
                {getFieldDecorator('summary', {
                  initialValue: data ? data.summary : '',
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="备注" {...ItemLayout}>
                {getFieldDecorator('remark', {})(<Input />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
        <Card title="联系信息">
          <Row>
            <Col span={10}>
              <FormItem label="所在地区" {...ItemLayout2}>
                {getFieldDecorator('region', {
                  initialValue: data ? data.region : [],
                })(
                  <Cascader
                    options={chinaAddressOptions}
                    onChange={this.chaneRegion}
                    changeOnSelect
                    placeholder="请选择地址"
                  />,
                )}
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span={20}>
              <FormItem label="详细地址" {...ItemLayout}>
                {getFieldDecorator('addr', {
                  initialValue: data ? data.addr : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="联系人" {...ItemLayout2}>
                {getFieldDecorator('contactName', {
                  rules: [{ required: true, message: '请输入联系人!' }],
                  initialValue: data ? data.contactName : '',
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="职位" {...ItemLayout2}>
                {getFieldDecorator('contactDep', {
                  initialValue: data ? data.contactDep : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="联系电话" {...ItemLayout2}>
                {getFieldDecorator('contactTel', {
                  initialValue: data ? data.contactTel : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
        </Card>

        <Card title="其他信息">
          <Row>
            <Col span={10}>
              <SelectUser
                onChange={this.changeOrderUser}
                user={{ uuid: data.orderUuid, name: data.orderName }}
                {...this.props}
                ItemLayout={ItemLayout2}
                data={data}
                field={{ fieldName: '成单人', field: 'orderUuid' }}
              />
            </Col>
            <Col span={10}>
              <SelectUser
                onChange={this.changeRecommendUser}
                user={{
                  uuid: data.recommendUuid,
                  name: data.recommendName,
                }}
                data={data}
                ItemLayout={ItemLayout2}
                {...this.props}
                field={{ fieldName: '推荐人', field: 'recommendUuid' }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <SelectUser
                onChange={this.changeManagerUser}
                ItemLayout={ItemLayout2}
                user={{
                  uuid: data.managerUuid,
                  name: data.managerName,
                }}
                data={data}
                {...this.props}
                field={{ fieldName: '管理人', field: 'managerUuid' }}
              />
            </Col>
            <Col span={10}>
              <FormItem label="用户id" {...ItemLayout2}>
                {getFieldDecorator('userId', {
                  initialValue: data ? data.userId : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="是否有关联用户名" {...ItemLayout2}>
                {getFieldDecorator('related', {
                  initialValue: data ? data.related : 0,
                })(
                  <RadioGroup>
                    <Radio value={0}>否</Radio>
                    <Radio value={1}>是</Radio>
                  </RadioGroup>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="微信名" {...ItemLayout2}>
                {getFieldDecorator('wechat', {
                  initialValue: data ? data.wechat : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span={10}>
              <FormItem label="qq" {...ItemLayout2}>
                {getFieldDecorator('qq', { initialValue: data ? data.qq : '' })(<Input />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="手机" {...ItemLayout2}>
                {getFieldDecorator('tel', {
                  initialValue: data ? data.tel : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="客户来源" {...ItemLayout2}>
                {getFieldDecorator('source', {
                  initialValue: data ? data.source : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
        </Card>

        <Row>
          <Col span={18} style={{ marginBottom: 15, textAlign: 'right' }}>
            <Button style={{ marginRight: 10 }} type="primary" htmlType="submit">
              确定
            </Button>
            <Button style={{ marginRight: 10 }} onClick={goBack}>
              取消
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/custom/FormCustom.js